// extracted by mini-css-extract-plugin
export default {"mainContainer":"Styles_mainContainer__YSR5B","slider1":"Styles_slider1__Rzsd7","slider2":"Styles_slider2__zeL41","submittedForm":"Styles_submittedForm__O2u-t"};